import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-load-details',
  templateUrl: './load-details.component.html',
  styleUrls: ['./load-details.component.css']
})
export class LoadDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
